<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems"/>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" title_icon="list" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import monthlyCutService from '@/services/monthly_cuts'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'

export default {
  components: { SysServerTable, SysFilter },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Cortes de pago',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Fecha', value: 'end_date', filter: 'reverseDate' },
        { text: 'Acreedores', value: 'investor_count' },
        { text: 'Monto Inversión Inicial', value: 'amount', filter: 'formatCurrency' },
        { text: 'Monto Inversión Final', value: 'end_amount', filter: 'formatCurrency' },
        { text: 'Anexos', value: 'attachment_count' },
        { text: 'Corte (Día)', value: 'cut_day' },
        { text: 'Estatus', value: 'status' }
      ],
      items: [],
      filtered_items: [],
      error_message: 'Cargando Cortes',
      detail_route: 'monthly_cut',
      create_route: 'monthly_cut_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'cut_day',
          name: 'Día de corte',
          hint: 'Todos',
          icon: 'calendar-alt',
          type: 'select',
          value: '',
          options: [
            { value: '7', text: '7' },
            { value: '15', text: '15' },
            { value: '21', text: '21' },
            { value: 'last_day', text: 'Último de mes' }
          ],
          size: 6,
          validator: (item, value) => item.cut_day == value
        },
        {
          id: 'status',
          name: 'Estatus',
          hint: 'Todos',
          icon: null,
          type: 'select',
          value: '',
          options: [
            {value: 'Aprobado', text: 'Aprobado'},
            {value: 'Pendiente', text: 'Pendiente'}
          ],
          size: 6,
          validator: (item, value) => item.status === value
        },
        {
          id: 'investment_from',
          name: 'Inversión Desde',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.amount >= value
        },
        {
          id: 'investment_to',
          name: 'Inversión Hasta',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.amount <= value
        },
        {
          id: 'date_from',
          name: 'Fecha Desde',
          hint: 'mm/dd/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.end_date) >= new Date(value)
        },
        {
          id: 'date_to',
          name: 'Fecha Hasta',
          hint: 'mm/dd/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.end_date) <= new Date(value)
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      monthlyCutService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/monthly_cuts/MonthlyCuts.vue